function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "language");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings",
  transform: "translate(-31.000000, -183.000000)",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection-Copy-2",
  transform: "translate(10.000000, 165.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "language",
  transform: "translate(22.000000, 19.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,17.2727273 L0.909090909,17.2727273 C1.90909091,17.2727273 2.72727273,16.4545455 2.72727273,15.4545455 L2.72727273,14.5454545 L0.727272727,13.4545455 C0.0909090909,13.0909091 0.0909090909,12.1818182 0.727272727,11.8181818 L2.72727273,10.9090909 L2.72727273,9.09090909 L4.81818182,8.54545455 C5.54545455,8.36363636 5.72727273,7.54545455 5.27272727,7 L2.72727273,4.54545455 L2.72727273,0",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.36363636,12.7272727 L9.09090909,9.09090909 L9.09090909,3.63636364 C9.09090909,2.63636364 9.90909091,1.81818182 10.9090909,1.81818182 L18.1818182,1.81818182 C19.1818182,1.81818182 20,2.63636364 20,3.63636364 L20,10.9090909 C20,11.9090909 19.1818182,12.7272727 18.1818182,12.7272727 L11.8181818,12.7272727 L6.36363636,12.7272727 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.7272727,
  y1: 5.45454545,
  x2: 16.3636364,
  y2: 5.45454545,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.7272727,
  y1: 9.09090909,
  x2: 14.5454545,
  y2: 9.09090909,
  id: "Path"
})))));

var SvgLanguage = function SvgLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/language.c4179512.svg";
export { ForwardRef as ReactComponent };